import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { DashboardApi, RecentMember } from "../../../apis/api/DashboardApi";
import { GetNews } from "../../../apis/api/NewsApi";
import BotResponseLayout from "./BotResponseLayout";

function BotDashboardResponse({ actionProvider }) {
  const dispatch = useDispatch();
  const [timeLeft, setTimeLeft] = useState(null);

  const { dashboardData } = useSelector((state) => state.DashboardSlice);
  const { news } = useSelector((state) => state.NewsSlice);
  const company_id = Cookies.get("company_id");
  const user_id = Cookies.get("userID");

  const dashboardOptions = [
    { label: "1. Membership Expiry Countdown", action: actionProvider.handleExpiryCountdown },
    { label: "2. Statistics Cards", action: actionProvider.handleStatistics },
    { label: "3. News Section", action: actionProvider.handleNewsInDashboard},
    { label: "4. Recent Members", action: actionProvider.handleRecentMembers },
    { label: "5. Members by Country", action: actionProvider.handleMembersByCountry },
  ];

  const buttonStyle = {
    width: "100%",
    padding: "10px 15px",
    margin: "4px 0",
    borderRadius: "8px",
    border: "none",
    backgroundColor: "rgb(0, 89, 164)",
    color: "#fff",
    fontSize: "16px",
    cursor: "pointer",
    transition: "background-color 0.3s, transform 0.2s",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  };

  useEffect(() => {
    if (!dashboardData || Object.keys(dashboardData).length === 0) {
      dispatch(DashboardApi({ company_id, user_id }));
    }
    if (!news || news.length === 0) {
      dispatch(GetNews());
    }
    dispatch(RecentMember());
  }, [dispatch, dashboardData, news, company_id, user_id]);

  useEffect(() => {
    if (!dashboardData?.membership_expire) return;

    const expiryTimestamp = Number(dashboardData.membership_expire) * 1000;
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = expiryTimestamp - now;

      if (distance <= 0) {
        clearInterval(interval);
        setTimeLeft({});
      } else {
        setTimeLeft({
          days: Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours: Math.floor(
            (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          ),
          minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        });
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [dashboardData?.membership_expire]);

  return (
    <BotResponseLayout actionProvider={actionProvider}>
      
      <div style={{ textAlign: "center", marginBottom: "10px" }}>
        <img
          src="/m_dashboard.png" // 👉 replace with your actual image path
          alt="Dashboard Preview"
          style={{
            maxWidth: "100%",
            borderRadius: "10px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
          }}
        />
        <p style={{ fontSize: "14px", marginTop: "6px", color: "#444" }}>
          This is your Dashboard overview.
        </p>
      </div>

      <p>Dashboard sections: </p>

      {/* Buttons */}
      {dashboardOptions.map((obj, idx) => (
        <button
          onClick={obj.action}
          key={idx}
          style={buttonStyle}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "rgb(0, 100, 200)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "rgb(0, 89, 164)")
          }
        >
          {obj.label}
        </button>
      ))} 
    </BotResponseLayout>
  );
}

export default BotDashboardResponse;
